/**
 * 公式渲染 — 用 KaTeX 渲染 LaTeX 源码
 *
 * 对齐 features.md 1.17：公式渲染
 */

import { useMemo, useState } from 'react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

interface FormulaBlockProps {
  latex: string;
  original?: string;
}

export function FormulaBlock({ latex, original }: FormulaBlockProps) {
  const [showSource, setShowSource] = useState(false);

  const html = useMemo(() => {
    try {
      return katex.renderToString(latex, {
        displayMode: true,
        throwOnError: false,
        errorColor: '#C85A5A',
      });
    } catch {
      return `<span style="color:#C85A5A">公式渲染失败</span>`;
    }
  }, [latex]);

  return (
    <div className="my-3">
      <div
        className="px-4 py-3 bg-warm-white dark:bg-warm-dark rounded-md overflow-x-auto cursor-pointer"
        onClick={() => setShowSource(!showSource)}
        dangerouslySetInnerHTML={{ __html: html }}
      />
      {showSource && (
        <div className="mt-1 px-3 py-1.5 rounded-md bg-oasis/5 border border-oasis/20">
          <code className="text-xs font-mono text-oasis">{latex}</code>
          {original && (
            <p className="text-xs text-charcoal/40 dark:text-charcoal-light/40 mt-0.5">{original}</p>
          )}
        </div>
      )}
    </div>
  );
}
